import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

export const getCategoryRequest = () => ({ type: 'GET_CATEGORY_REQUEST' })
export const getCategorySuccess = (data) => ({ type: 'GET_CATEGORY_SUCCESS', data })
export const getCategoryFailure = (error) => ({ type: 'GET_CATEGORY_FAILURE', error })

export const addCategoryRequest = () => ({ type: 'ADD_CATEGORY_REQUEST' })
export const addCategorySuccess = () => ({ type: 'ADD_CATEGORY_SUCCESS' })
export const addCategoryFailure = (error) => ({ type: 'ADD_CATEGORY_FAILURE', error })

export const updateCategoryRequest = () => ({ type: 'UPDATE_CATEGORY_REQUEST' })
export const updateCategorySuccess = () => ({ type: 'UPDATE_CATEGORY_SUCCESS' })
export const updateCategoryFailure = (error) => ({ type: 'UPDATE_CATEGORY_FAILURE', error })

export const deleteCategoryRequest = () => ({ type: 'DELETE_CATEGORY_REQUEST' })
export const deleteCategorySuccess = () => ({ type: 'DELETE_CATEGORY_SUCCESS' })
export const deleteCategoryFailure = (error) => ({ type: 'DELETE_CATEGORY_FAILURE', error })

export const getCategory = () => {
  return (dispatch) => {
    dispatch(getCategoryRequest())
    fetch(URL.BASE_URL + URL.END_POINT.categories, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((data) => {
        dispatch(getCategorySuccess(data))
      })
      .catch((error) => {
        dispatch(getCategoryFailure(error.message))
        toast.error(error.message)
      })
  }
}

export const addCategory = (newCategory) => {
  return (dispatch) => {
    dispatch(addCategoryRequest())
    fetch(URL.BASE_URL + URL.END_POINT.categories, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: newCategory,
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(addCategorySuccess())
        toast.success('Category added successfully')
        dispatch(getCategory())
      })
      .catch((error) => {
        dispatch(addCategoryFailure(error.message))
        toast.error(error.message)
      })
  }
}

export const updateCategory = (id, updatedCategory) => {
  return (dispatch) => {
    dispatch(updateCategoryRequest())
    fetch(URL.BASE_URL + URL.END_POINT.categories + id, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: updatedCategory,
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(updateCategorySuccess())
        toast.success('Category updated successfully')
        dispatch(getCategory())
      })
      .catch((error) => {
        dispatch(updateCategoryFailure(error.message))
        toast.error(error.message)
      })
  }
}

export const deleteCategory = (id) => {
  return (dispatch) => {
    dispatch(deleteCategoryRequest())
    fetch(URL.BASE_URL + URL.END_POINT.categories + id, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(deleteCategorySuccess())
        toast.success('Category deleted successfully')
        dispatch(getCategory())
      })
      .catch((error) => {
        dispatch(deleteCategoryFailure(error.message))
        toast.error(error.message)
      })
  }
}

const initialState = {
  categories: [],
  loading: false,
  error: null,
}

export const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_CATEGORY_REQUEST':
    case 'ADD_CATEGORY_REQUEST':
    case 'UPDATE_CATEGORY_REQUEST':
    case 'DELETE_CATEGORY_REQUEST':
      return { ...state, loading: true, error: null }
    case 'GET_CATEGORY_SUCCESS':
      return { ...state, categories: action.data.categories, loading: false, error: null }
    case 'ADD_CATEGORY_SUCCESS':
    case 'UPDATE_CATEGORY_SUCCESS':
    case 'DELETE_CATEGORY_SUCCESS':
      return { ...state, loading: false, error: null }
    case 'GET_CATEGORY_FAILURE':
    case 'ADD_CATEGORY_FAILURE':
    case 'UPDATE_CATEGORY_FAILURE':
    case 'DELETE_CATEGORY_FAILURE':
      return { ...state, loading: false, error: action.error }
    default:
      return state
  }
}
